import de from '../translations/de/de';

export default {
  interpolation: { escapeValue: false },
  lng: 'de',
  resources: {
    de: de,
  },
};
